import React from 'react';
var SoMeLinks = function (props) {
    var _a = props.links, links = _a === void 0 ? [] : _a, _b = props.newTab, newTab = _b === void 0 ? false : _b, _c = props.small, small = _c === void 0 ? false : _c;
    var target = newTab ? '_blank' : undefined;
    var getClassName = function (circle, company) {
        return (circle ? 'some-circle' : '') +
            (company ? " some-" + company.toLowerCase() : '') +
            (small ? ' small' : '');
    };
    var linkClassName = function (company) {
        return company != 'Facebook'
            ? getClassName(true, company)
            : getClassName(false, 'facebook');
    };
    var icon = function (company) {
        return "fab fa-" + company.toLowerCase() + (company == 'LinkedIn' ? '-in' : '');
    };
    var getSpacingClass = function (isLastItem) {
        if (isLastItem) {
            return '';
        }
        return small ? 'mr-2' : 'mr-4';
    };
    var createItem = function (index, company, href, isLastItem) {
        return (React.createElement("li", { key: index, className: getSpacingClass(isLastItem) },
            React.createElement("a", { target: target, className: linkClassName(company), href: href, "aria-label": "Go to DNV Software's " + company + ' page', title: company },
                React.createElement("i", { className: icon(company) }))));
    };
    return (React.createElement("ul", { className: "footer-some" }, links === null || links === void 0 ? void 0 : links.map(function (link, i) {
        return createItem(i, link.company, link.href, i === links.length - 1);
    })));
};
export default React.memo(SoMeLinks);
